import { render, staticRenderFns } from "./AptoDialog.vue?vue&type=template&id=60b5fdc9&scoped=true&"
import script from "./AptoDialog.vue?vue&type=script&lang=js&"
export * from "./AptoDialog.vue?vue&type=script&lang=js&"
import style0 from "./AptoDialog.vue?vue&type=style&index=0&id=60b5fdc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5fdc9",
  null
  
)

export default component.exports